import { render } from "./PrevSvg.vue?vue&type=template&id=3736c0b6"
import script from "./PrevSvg.vue?vue&type=script&lang=js"
export * from "./PrevSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__